import createReactComponent from '../createReactComponent';
export default createReactComponent('user-check', 'IconUserCheck', [
  ['path', { d: 'M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0', key: 'svg-0' }],
  ['path', { d: 'M6 21v-2a4 4 0 0 1 4 -4h4', key: 'svg-1' }],
  ['path', { d: 'M15 19l2 2l4 -4', key: 'svg-2' }],
]);
